import { attachmentService } from '@/services/attachment';
import { useEffect, useState } from 'react';

interface UseThumbnailReturn {
  src: string;
  loading: boolean;
  error: boolean;
}

export const useThumbnail = (
  thumbnailPath?: string | null,
  fallbackPath: string = '/images/noImage.png'
): UseThumbnailReturn => {
  const [src, setSrc] = useState<string>(fallbackPath);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    const loadThumbnail = async () => {
      if (!thumbnailPath) {
        setSrc(fallbackPath);
        setLoading(false);
        setError(false);
        return;
      }

      setLoading(true);
      setError(false);

      try {
        const url = attachmentService.getThumbnailDirectUrl(thumbnailPath, fallbackPath);
        setSrc(url);
        setError(false);
      } catch (err) {
        console.error('Error loading thumbnail:', err);
        setSrc(fallbackPath);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadThumbnail();
  }, [thumbnailPath, fallbackPath]);

  return { src, loading, error };
};
